var _rect, _text, _text2, _text3, _g, _text4, _g2, _g3, _rect2, _text5, _text6, _text7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForesightFig1StylesByModes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 640",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 640,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "One skill, forty-five ways in")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Five interaction styles by nine operational modes, both chosen by number at intake")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 118,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#16A34A",
    fontWeight: 600
  }, "NINE OPERATIONAL MODES")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 128,
    width: 88,
    height: 42,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 384,
    y: 146,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Signal"), /*#__PURE__*/React.createElement("text", {
    x: 384,
    y: 160,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Scan"), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 128,
    width: 88,
    height: 42,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 478,
    y: 153,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Scenario"), /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 128,
    width: 88,
    height: 42,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 153,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Forecast"), /*#__PURE__*/React.createElement("rect", {
    x: 622,
    y: 128,
    width: 88,
    height: 42,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 666,
    y: 153,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Artifact"), /*#__PURE__*/React.createElement("rect", {
    x: 716,
    y: 128,
    width: 88,
    height: 42,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 153,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Implications"), /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 128,
    width: 88,
    height: 42,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 854,
    y: 153,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Challenge"), /*#__PURE__*/React.createElement("rect", {
    x: 904,
    y: 128,
    width: 88,
    height: 42,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 948,
    y: 153,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Backcast"), /*#__PURE__*/React.createElement("rect", {
    x: 998,
    y: 128,
    width: 88,
    height: 42,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 146,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Investment"), /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 160,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Memo"), /*#__PURE__*/React.createElement("rect", {
    x: 1092,
    y: 128,
    width: 88,
    height: 42,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 1136,
    y: 146,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Historical"), /*#__PURE__*/React.createElement("text", {
    x: 1136,
    y: 160,
    fontSize: 10.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Pattern"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 118,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#7C3AED",
    fontWeight: 600
  }, "FIVE INTERACTION STYLES")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 190,
    width: 268,
    height: 66,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 217,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "1. Interactive"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 238,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "checks in and challenges at every step"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 266,
    width: 268,
    height: 66,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 293,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "2. Guided"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 314,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "2-3 questions, then a complete draft"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 342,
    width: 268,
    height: 66,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 369,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "3. Auto"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 390,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "one pass, then self-evaluates"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 418,
    width: 268,
    height: 66,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 445,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "4. Brief"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 466,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "dense output, no preamble"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 494,
    width: 268,
    height: 66,
    rx: 12,
    fill: "#F3EEFB",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 521,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "5. New to this"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 542,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "plain language, no assumed vocabulary"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#D4DDD6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 223,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478,
    cy: 223,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572,
    cy: 223,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 223,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 223,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854,
    cy: 223,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948,
    cy: 223,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 223,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136,
    cy: 223,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 299,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478,
    cy: 299,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572,
    cy: 299,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 299,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 299,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854,
    cy: 299,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948,
    cy: 299,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 299,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136,
    cy: 299,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 375,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478,
    cy: 375,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572,
    cy: 375,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 375,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 375,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854,
    cy: 375,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948,
    cy: 375,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 375,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136,
    cy: 375,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 451,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478,
    cy: 451,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572,
    cy: 451,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 451,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 451,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854,
    cy: 451,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948,
    cy: 451,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 451,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136,
    cy: 451,
    r: 5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 506,
    width: 840,
    height: 42,
    rx: 8,
    fill: "#F3EEFB",
    stroke: "#7C3AED",
    strokeWidth: 1.2,
    strokeDasharray: "4 3"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 527,
    fontSize: 12.5,
    fill: "#4A2A85",
    textAnchor: "middle"
  }, "This row never sees the mode menu. It gets seven intents in plain words,")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 542,
    fontSize: 12.5,
    fill: "#4A2A85",
    textAnchor: "middle"
  }, "each teaching the real mode name in parentheses.")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 303,
    fontSize: 10,
    fill: "#16A34A",
    textAnchor: "end",
    fontWeight: 600
  }, "default")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForesightFig1StylesByModes);
export default __webpack_public_path__ + "static/media/foresight-fig1-styles-by-modes.1b79d04dde52aaad92961f460d11e9e2.svg";
export { ForwardRef as ReactComponent };